import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { useSelector } from 'react-redux';
import { getFieldOptions } from '../plagins/data/commponentOptions';
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { addRecordToCache, createFetchDataServer, getTableData, updateRecordInCache } from '../../../database/fetchData';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedCustomers, fullSelectedGraves, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';

const NAME_ENTITY = ' קבורה';

function BurialCreate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormBurials.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataBurial, getEntitiesByAttr, getEntityByAttr } = useQueries();

  const location = useLocation();
  const navigate = useNavigate();
  const { grave } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת קבורה`);
  }, [location.pathname]);

  
  // איזור המשתנים והסטייטים
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);
  const [graves, setGraves] = useState([]);
  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);

  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loading, setLoading] = useState(true); // מצב טעינה
  const [loadingData, setLoadingData] = useState(false);

  const [recordChild, setRecordChild] = useState(-1);
  const [isEdit, setIsEdit] = useState(false);


  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId' || field.name === 'lineId'
      || field.name === 'areaGraveId' || field.name === 'graveId'
      || (field.name === 'clientId' && getEntityByAttr(context?.contextPurchases, 'graveId', grave?.unicId)?.unicId) ? true : false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled,
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {
    const purchase = getEntityByAttr(context?.contextPurchases, 'graveId', data?.graveId);
    const burial = getEntityByAttr(context?.contextBurials, 'graveId', data?.graveId);

    let customers = context?.contextCustomers?.filter((cust) => {
      let mycust = purchase?.clientId || burial?.clientId || null;
      if (cust?.unicId !== mycust) {
        if (cust?.statusCustomer !== 2 && cust?.statusCustomer !== 3 && cust?.statusCustomer !== 0) {
          return cust;
        }
      } else {
        return cust;
      }
      return;
    });



    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.cemeteryId)));
    setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', data?.blockId)));
    setRows(fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', data?.plotId), false, null));
    setAreaGraves(fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'unicId', data?.areaGraveId)));
    setGraves(fullSelectedGraves(getEntitiesByAttr(context?.contextGraves, 'areaGraveId', data?.areaGraveId)));
    setClients(fullSelectedCustomers(customers));
    setContacts(fullSelectedCustomers(context?.contextCustomers));
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    if (grave?.unicId) {
      const purchase = getEntityByAttr(context?.contextPurchases, 'graveId', grave?.unicId);

      let data = getEntityByAttr(context?.contextGraves, 'unicId', grave?.unicId) || {};       

      let initialFormValues = myColumns()
      .filter((field) => field?.name)
      .reduce(
        (acc, field) => {
          let fieldValue = data[field.name] || '';
          // כיון שזהוא טופס חדש, אין תאריך וזה רק משמש לתאריך דיפולטיבי
          if (field.input === 'date') {
            if (field.name === 'dataOpening') {
              fieldValue = format(new Date(), 'yyyy-MM-dd');
            }
          }    
          return {
            ...acc,
            [field.name]: fieldValue
          };
        },{}
      );

      initialFormValues = {...initialFormValues, graveId: data?.unicId,
        cemeteryId: data?.cemeteryId, blockId: data?.blockId, plotId: data?.plotId, blockId: data?.blockId, cemeteryId: data?.cemeteryId,
        purchaseId: purchase?.unicId, purchaseSerial: purchase?.serialPurchaseId, 
        clientId: purchase?.clientId
      }
      delete initialFormValues?.id 
      
      fieldAuto(initialFormValues)

      if (Object.keys(formValues).length === 0) {
        setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
      }
    }
  };


  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);


  const handleChange = (event) => {
    let newFormValues = formValues;
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {

      let newFormValues = { ...formValues };

      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      delete newFormValues?.areaGraveId;
      delete newFormValues?.purchaseSerial;
      
      setLoadingData(true);

      const unicId = uuidv4()
      
      // הכנת הנתונים לשרת
      let filteredClient = getEntityByAttr(context?.contextCustomers, 'unicId', newFormValues?.clientId);
      delete filteredClient.fullNameHe

      let updateGrave = getEntityByAttr(context?.contextGraves, 'unicId', grave?.unicId);
      delete updateGrave.cemeteryId
      delete updateGrave.blockId
      delete updateGrave.plotId
      delete updateGrave.lineId
      delete updateGrave.cemeteryNameHe
      delete updateGrave.blockNameHe
      delete updateGrave.plotNameHe
      delete updateGrave.lineNameHe
      delete updateGrave.cemeteryNameEn
      delete updateGrave.blockNameEn
      delete updateGrave.plotNameEn
      delete updateGrave.lineNameEn
      delete updateGrave.areaGraveNameHe
      delete updateGrave.areaGraveNameEn

      let updatedFormValues = {
        ...newFormValues,
        updateGrave: { ...updateGrave, graveStatus: 3 },
        updateCustomer: { ...filteredClient, statusCustomer: 3, graveId: grave?.unicId }
      };

      // שאילתה ראשונה
      let res = await addOrUpdateDataBurial(updatedFormValues, unicId);
      
      // בדיקת התוצאה
      if (res === 200) {
        // let { updateGrave, updateCustomer, ...updateBurial } = updatedFormValues

        // context?.setContextBurials((prev) => {
        //   // בדיקה אם הערך קיים בסטייט
        //   const existingIndex = prev.findIndex((item) => item.unicId === updateBurial.unicId);
        
        //   addRecordToCache(updateBurial, 'dataBurials');

        //   if (existingIndex !== -1) {
        //     // אם הערך קיים, מעדכן אותו
        //     const updatedState = [...prev];
        //     updatedState[existingIndex] = { ...updatedState[existingIndex], ...updateBurial };
        //     return updatedState;
        //   } else {
        //     // אם הערך לא קיים, מוסיף אותו
        //     return [...prev, updateBurial];
        //   }
        // });
        // context?.setContextCustomers((prev) => {
        //   // בדיקה אם הערך קיים בסטייט
        //   const existingIndex = prev.findIndex((item) => item.unicId === updateCustomer.unicId);
                    
        //   updateRecordInCache(updateCustomer, 'dataCustomers')

        //   if (existingIndex !== -1) {
        //     // אם הערך קיים, מעדכן אותו
        //     const updatedState = [...prev];
        //     updatedState[existingIndex] = { ...updatedState[existingIndex], ...updateCustomer };
        //     return updatedState;
        //   } else {
        //     // אם הערך לא קיים, מוסיף אותו
        //     return [...prev, updateCustomer];
        //   }
        // });
        // context?.setContextGraves((prev) => {
        //   // בדיקה אם הערך קיים בסטייט
        //   const existingIndex = prev.findIndex((item) => item.unicId === updateGrave.unicId);
        
        //   updateRecordInCache(updateGrave.unicId, updateGrave, 'dataGraves')

        //   if (existingIndex !== -1) {
        //     // אם הערך קיים, מעדכן אותו
        //     const updatedState = [...prev];
        //     updatedState[existingIndex] = { ...updatedState[existingIndex], ...updateGrave };
        //     return updatedState;
        //   } else {
        //     // אם הערך לא קיים, מוסיף אותו
        //     return [...prev, updateGrave];
        //   }
        // });
        
        setLoadingData(false);
        navigate(-1);
      } else {
        // טיפול במקרה של כישלון
        console.error('השאילתה נכשלה', res);
        setLoadingData(false);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
        const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves && dataPurchases && dataBurials) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves', 'customers', 'purchases'], token, handlePartialUpdate);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <FormTemplate
      title={`${isEdit ? 'עריכת' : 'הוספת'} ${NAME_ENTITY}`}
      btn={`${isEdit ? 'עדכן' : 'שמור'}`}
      fields={fieldsWithDynamicDisabled}
      columns={fieldsWithDynamicDisabled}
      formValues={formValues}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      errors={errors}
      recordChild={recordChild !== -1}
      options={{
        cemeteryId: cemeteries,
        blockId: blocks,
        plotId: plots,
        lineId: rows,
        areaGraveId: areaGraves,
        graveId: graves,
        clientId: clients,
        contactId: contacts,
        plotType: getFieldOptions('plotType', optionsFields, true),
        graveType: getFieldOptions('graveType', optionsFields, true),
        resident: getFieldOptions('resident', optionsFields, true),
        priceDefinition: getFieldOptions('priceDefinition', optionsFields, true),
        buyerStatus: getFieldOptions('buyerStatus', optionsFields, true),
        isFuneralPayments: getFieldOptions('isFuneralPayments', optionsFields, true),
        numOfPayments: getFieldOptions('numOfPayments', optionsFields, true)
      }}
    />
  );
}

export default BurialCreate;
